module.exports = __webpack_public_path__ + "static/media/phoneMockup2.0f9608c2.png";